export default "__VITE_ASSET__KqhwTnWb__"